import React from 'react';
import PropTypes from 'prop-types';

const TestimonialBox = ({ author, authorInfo, avatar, quote }) => (
  <div className="testimonial-box">
    <p className="testimonial-box__quote">
      {quote}
    </p>
    <div className="testimonial-box__author">
      <img src={avatar} alt={author} />
      <div>
        <strong>{author}</strong><br />
        {authorInfo}
      </div>
    </div>
  </div>
);

TestimonialBox.propTypes = {
  avatar: PropTypes.string.isRequired,
  quote: PropTypes.string.isRequired,
  author: PropTypes.string.isRequired,
  authorInfo: PropTypes.string.isRequired
};

export default TestimonialBox;
